export const promiseQueue = () => {
  let promise = Promise.resolve()

  let isCanceled = false

  return {
    // `fn` should be a function that returns a Promise, for example: () => Promise.resolve()
    push(fn) {
      promise = promise.then(response => (isCanceled ? Promise.resolve() : fn(response)))

      return promise
    },
    cancel() {
      isCanceled = true
    },
  }
}
